import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import isNaN from 'lodash/isNaN';

import Markup from '../../../../markup';
import CheckBox from "../../../Global/CheckBox";
import SelectBox from '../../../Global/SelectBox';
import TooltipHover from '../../../Global/TooltipHover';
import { device } from '../../../../const/device';
import Toggle from '../../../Global/Toggle';
import BuilderContext from '../../../../builder/hooks/context';
import FontLoader from "../../../../builder/utils/FontLoader";
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';


const Names = {
  title: 'Gamertag',
  fullname: 'Full Name',
  number: 'Number'
};

const fontCache = new Set;

function fontMemo(fontName:string): string | null {
  return fontCache.has(fontName)? null: (fontCache.add(fontName), fontName);
}

const ColorHelpText = <Markup.Screen.Color.HelpTextContainer padding={8}>Change color</Markup.Screen.Color.HelpTextContainer>

const InputBlock = ({ id, data, colorData, setData, themeColor }) => {
  const history = useHistory();
  const isMobile = useMediaQuery({ query: `(${device.tabletS})` });

  const handleInput = ({ target: { value } }, id) => {
    if(Names[id] === Names.number && (value?.length && isNaN(Number(value)) || value?.length > 2)) return;
    setData({ value, enabled: !!value?.length })
  };

  return (
    <>
      {!isMobile ? <Markup.Screen.Name.InputLabel htmlFor={`label_${id}`}>{Names[id]}</Markup.Screen.Name.InputLabel> : null}
      <Markup.Screen.Name.InputWrapper>
        <Markup.Global.Input.CheckboxContainer>
          <Markup.Global.Input.Item id={`label_${id}`} value={data?.value} placeholder={data?.placeholder} onChange={(e) => handleInput(e, id)} themeColor={themeColor}/>
          <CheckBox active={data?.enabled} disabled={!data?.value?.length} onClick={() => setData({ enabled: !data?.enabled })} />
        </Markup.Global.Input.CheckboxContainer>
        <TooltipHover content={ColorHelpText} width={90} bottom>
          <Markup.Screen.Name.TextColorItem themeColor={themeColor} color={colorData} onClick={() => history.push(`/color/text/${id}`)} />
        </TooltipHover>
      </Markup.Screen.Name.InputWrapper>
    </>
  );
};

const mobileInputList = {
  title: 'Tag',
  fullname: 'Name',
  number: 'Number',
  font: 'Font',
};

function NameNaming() {
  const { builder } = useContext(BuilderContext);
  const isMobile = useMediaQuery({ query: `(${device.tabletS})` })
  const [mobileInput, setMobileInput] = useState('title');

  useEffect(() => {
    trackSubStage('Specs', 'Naming');
    trackBeforeUnload('Naming');
  }, []);

  const loadFont = (font:string) => {
    FontLoader(font, (loadedFont) => builder.membersData.setMemberFontFamily(loadedFont));
  }

  const updateAllFonts = (font) => {
    
    if(fontMemo(font)){
      loadFont(font);
    }else builder.membersData.setMemberFontFamily(font);
  };

  return (
    <>
      <Markup.Screen.Name.Wrapper>
        <Markup.Screen.Name.DisableOverlayOther themeColor={builder.membersData.colorTheme} disOverOther={builder.membersData.members[builder.membersData.currentMemberIndex].resultAddedCart}/>
        {Object.keys(Names)
          .map(textId => (
            (isMobile && mobileInput === textId || !isMobile) && builder?.options?.text?.includes(textId) &&
              <Markup.Screen.Name.ControlItem key={textId}>
                <InputBlock
                  id={textId} 
                  data={builder.membersData.currentMember.text[textId]}
                  colorData={builder.membersData.memberTextColors[textId]}
                  setData={textData => builder.membersData.updateMember({ text: { [textId]: textData }  })}
                  themeColor={builder.membersData.colorTheme}
                />
              </Markup.Screen.Name.ControlItem>
            )
          )
        }

        {isMobile && mobileInput !== 'font' ? null :
          <Markup.Screen.Name.ControlItem>
            {!isMobile ? <Markup.Screen.Name.InputLabel htmlFor={`label_font`}>Text font family</Markup.Screen.Name.InputLabel> : null}
            <SelectBox
              selected={builder.membersData.memberFontFamily}
              setSelected={font => updateAllFonts(font)}
              items={builder.modelData.fonts}
              themeColor={builder.membersData.colorTheme}
            />
          </Markup.Screen.Name.ControlItem>
        }
        {isMobile ? <Toggle compact items={mobileInputList} active={mobileInput} setActive={item => setMobileInput(item)} /> : null}
      </Markup.Screen.Name.Wrapper>
    </>
  );
}

export default React.memo(NameNaming);